import {LitElement, html, css, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import {hoverInfo, widgetButton} from '../../css/styleSets';
import custom from '../../../icons/custom';
import StandardColourOfChoice from '../../../icons/StandardColourOfChoice';
import colorIcon from '../../../icons/colorIcon';

@customElement('color-select-item')
export class ColorSelectItem extends connect(store)(LitElement) {

	@property({type: Object})
	option = {};

	@property({type: String})
	selected = '';

	@property({type: String})
	action = '';

	@property({type: Function})
	callback = null;

	@property({type: Boolean})
	canBeSelected = true;

	@property({type: Boolean})
	hideDisabled = false

	static styles = [
		widgetButton,
		hoverInfo,
		css`
			:host {
				flex-grow: 1;
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
				flex-grow: 1;
			}

			.hidden {
				display: none;
			}

			.item button {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			button svg {
				fill: currentColor;
				width: 16px;
				height: 16px;
			}

		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}
	isSelected() {
		return this.selected+'' === this.option.id+'';
	}

	isExcluded() {
		return false;
	}

	isDisabeled() {
		return !this.canBeSelected;
	}

	canBeExcluded() {
		return true;
	}

	async setOption() {
		if (this.action !== '') {
			store.dispatch(
				{
					type: this.action,
					payload: {
						id: this.option.id
					}
				}
			);
		} else if (this.callback && typeof this.callback === 'function') {
			this.callback(this.option.id);
		}
	}

	render() {
		let icon = colorIcon;
		switch (this.option.displayColour) {
			case 'custom':
				icon = custom;
				break;
			case 'StandardColourOfChoice':
				icon = StandardColourOfChoice;
				break;
		}
		return html`
			<div class="item ${classMap({selected: this.isSelected(), disabled: this.isDisabeled(), hideDisabled: this.hideDisabled, fixed: !this.canBeExcluded()})}">
				<button @click="${this.setOption}" style="color: ${unsafeCSS(this.option.displayColour)}">
					${icon}
				</button>
				${when(this.option.info && this.option.info !== '' && this.option.info !== null, () => html`
					<div class="hoverinfo">
						<div class="content">${this.option.info[this.lang]}</div>
					</div>
				`)}
			</div>
		`;
	}
}
